import { Button, DatePicker, Empty, Form, InfiniteScroll, List, NavBar, Popup, Space, Tag, Toast } from 'antd-mobile';
import { CloseCircleOutline, FilterOutline, RightOutline } from 'antd-mobile-icons';
import dayjs from 'dayjs';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { listMyBorrowHis } from '../componet/service';
import '../styles/BorrowHisPage.css';

const BorrowHisPage = () => {
    const navigate = useNavigate();
    const [records, setRecords] = useState([]);
    const [loading, setLoading] = useState(true);
    const [filterVisible, setFilterVisible] = useState(false);
    const [page, setPage] = useState(1);
    const [hasMore, setHasMore] = useState(true);
    const pageSize = 20;
    const [clear, setClear] = useState(true);
    const [filter, setFilter] = useState({
        borrowStatus: '',
        borrowStartTime: null,
        borrowEndTime: null
    });
    const [filterConfig, setFilterConfig] = useState(filter);
    const allStatus = ['外借中', '申请转移', '已转移', '申请归还', '批准归还', '已归还'];
    const [form] = Form.useForm();

    // 获取借出记录
    const fetchBorrowRecords = async (pageNum = 1, isLoadMore = false) => {
        if (pageNum === 1) {
            setLoading(true);
        }
        try {
            // 这里替换为实际的API调用
            // const response = await fetchBorrowHistory(filter, pageNum, pageSize);
            const res = await listMyBorrowHis(pageNum, pageSize, filter)
            // 模拟数据 - 实际项目中应替换为API调用
            const hisList = res.data.content;
            // 更新数据和分页状态
            let totalRecords = [...records, ...hisList];
            setRecords(totalRecords);
            // 判断是否还有更多数据
            setHasMore(res.data.totalCnt > totalRecords.length);
            setPage(pageNum);
            setLoading(false);
        } catch (error) {
            Toast.show({
                icon: 'fail',
                content: '获取数据失败'
            });
            setLoading(false);
            setHasMore(false);
        }
    };

    useEffect(() => {
        setRecords([]);
        setPage(1);
        setHasMore(true);
        setClear(true);
    }, [filter]);

    useEffect(() => {
        if (clear) {
            fetchBorrowRecords(1, false);
            setClear(false);
        }
    }, [clear]);

    // 加载更多数据
    const loadMore = async () => {
        if (!hasMore) return;
        const nextPage = page + 1;
        await fetchBorrowRecords(nextPage, true);
    };
    // 应用筛选条件
    const applyFilter = (values) => {
        setFilter({ ...filterConfig });
        setFilterVisible(false);
    };

    // 重置筛选条件
    const resetFilter = () => {
        const emptyFilter = {
            borrowStatus: '',
            borrowStartTime: null,
            borrowEndTime: null
        };
        setFilter(emptyFilter);
        setFilterConfig(emptyFilter);
        form.resetFields();
        setFilterVisible(false);
    };

    // 查看详情
    const viewDetail = (record) => {
        navigate(`/borrow-detail/${record.id}`, { state: { record } });
    };

    // 渲染状态标签
    const renderStatusTag = (status) => {
        if (status === '已归还') {
            return <Tag color='success' fill='outline'>{status}</Tag>;
        }
        return <Tag color='primary' fill='outline'>{status}</Tag>;
    };

    return (
        <div className="borrow-history-container">
            <NavBar
                back="返回"
                onBack={() => navigate(-1)}
                right={
                    <FilterOutline
                        fontSize={24}
                        onClick={() => setFilterVisible(true)}
                    />
                }
            >
                我的借出记录
            </NavBar>

            {/* 筛选条件摘要 */}
            {(filter.borrowStatus || filter.borrowStartTime || filter.borrowEndTime) && (
                <div className="filter-summary">
                    <Space wrap>
                        {filter.borrowStatus && (
                            <Tag
                                closable
                                onClose={() => setFilter({ ...filter, borrowStatus: '' })}
                            >
                                状态: {filter.borrowStatus}
                            </Tag>
                        )}
                        {(filter.borrowStartTime || filter.borrowEndTime) && (
                            <Tag
                                closable
                                onClose={() => setFilter({ ...filter, borrowStartTime: null, borrowEndTime: null })}
                            >
                                时间: {filter.borrowStartTime ? new Date(filter.borrowStartTime).toLocaleDateString() : '不限'}
                                至
                                {filter.borrowEndTime ? new Date(filter.borrowEndTime).toLocaleDateString() : '不限'}
                            </Tag>
                        )}
                        <Button
                            size='mini'
                            onClick={resetFilter}
                        >
                            清除全部
                        </Button>
                    </Space>
                </div>
            )}

            {/* 记录列表 */}
            {loading && page === 1 ? (
                <div className="loading-container">加载中...</div>
            ) : records.length > 0 ? (
                <>
                    <List className="borrow-list">
                        {records.map(record => (
                            <List.Item
                                key={record.id}
                                onClick={() => viewDetail(record)}
                                arrow={<RightOutline />}
                                extra={renderStatusTag(record.borrowStatus)}
                                description={
                                    <div className="item-description">
                                        <div>出借人: {record.borrower}</div>
                                        <div>出借时间: {record.borrowTime}</div>
                                    </div>
                                }
                            >
                                <div className="item-title">
                                    <span className="asset-no">{record.assetNo}</span>
                                    <span className="device-type">{record.typeName}</span>
                                </div>
                                <div className="device-name">{record.name}</div>
                            </List.Item>
                        ))}
                    </List>

                    {/* 无限滚动加载组件 */}
                    <InfiniteScroll loadMore={loadMore} hasMore={hasMore} />
                </>
            ) : (
                <Empty
                    className="empty-container"
                    image={<CloseCircleOutline style={{ fontSize: 48 }} />}
                    description="暂无借出记录"
                />
            )}

            {/* 筛选弹窗 */}
            <Popup
                visible={filterVisible}
                onMaskClick={() => setFilterVisible(false)}
                position="right"
                bodyStyle={{ width: '80vw' }}
            >
                <div className="filter-container">
                    <NavBar
                        back="取消"
                        onBack={() => setFilterVisible(false)}
                    >
                        筛选条件
                    </NavBar>

                    <Form
                        layout="vertical"
                        form={form}
                        onFinish={applyFilter}
                        footer={
                            <div className="filter-buttons">
                                <Button block onClick={resetFilter}>重置</Button>
                                <Button block type="submit" color="primary">应用</Button>
                            </div>
                        }
                    >
                        <Form.Header>出借状态</Form.Header>
                        <Form.Item name="borrowStatus">
                            <div className="status-options">
                                <Space wrap>
                                    <Tag
                                        color={filterConfig.borrowStatus === '' ? 'primary' : 'default'}
                                        onClick={() => setFilterConfig({ ...filterConfig, borrowStatus: '' })}
                                    >
                                        全部
                                    </Tag>
                                    {allStatus.map(status => (
                                        <Tag
                                            key={status}
                                            color={filterConfig.borrowStatus === status ? 'primary' : 'default'}
                                            onClick={() => setFilterConfig({ ...filterConfig, borrowStatus: status })}
                                        >
                                            {status}
                                        </Tag>
                                    ))
                                    }
                                </Space>

                            </div>
                        </Form.Item>

                        <Form.Header>出借时间</Form.Header>
                        <Form.Item name="borrowStartTime" label="开始日期"
                            trigger='onConfirm'
                            onClick={(e, datePickerRef) => {
                                datePickerRef.current?.open()
                            }}>
                            <DatePicker
                                value={filter.borrowStartTime}
                                onConfirm={(val) => {
                                    setFilterConfig({ ...filterConfig, borrowStartTime: dayjs(val).format('YYYY/MM/DD') })
                                }}
                            >
                                {value =>
                                    value ? dayjs(value).format('YYYY/MM/DD') : '请选择日期'
                                }
                            </DatePicker>
                        </Form.Item>
                        <Form.Item name="borrowEndTime" label="结束日期"
                            trigger='onConfirm'
                            onClick={(e, datePickerRef) => {
                                datePickerRef.current?.open()
                            }}>
                            <DatePicker
                                value={filter.borrowEndTime}
                                onConfirm={(val) => setFilterConfig({ ...filterConfig, borrowEndTime: dayjs(val).format('YYYY/MM/DD') })}
                            >
                                {(value) =>
                                    value ? dayjs(value).format('YYYY/MM/DD') : '请选择结束日期'
                                }
                            </DatePicker>
                        </Form.Item>
                    </Form>
                </div>
            </Popup>
        </div>
    );
};

export default BorrowHisPage;